import React, { useEffect, useState } from 'react'
import { Modal, Header, ModalContent } from './styles'
import { Backdrop, CloseButton } from 'src/global'
import useWindowModal from 'src/helpers/useWindowModal'

export default function PosPrintingModal() {
  const { isOpen, close } = useWindowModal('pos-printing-modal:change', (openModal, closeModal) => {
    window.openPosPrintingModal = openModal
    window.hidePosPrintingModal = closeModal
  })

  const [hasOpened, setHasOpened] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setHasOpened(true)
    }
  }, [isOpen])

  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <Modal className={isOpen ? 'open' : 'closed'} role="dialog" aria-modal="true" aria-label="Printare comenzi pe POS">
        <Header>
          <div className="title-wrapper">
            <div className="title">
              Printează comenzile folosind o imprimantă termică
              <span className="badge">NOU</span>
            </div>
          </div>
          <CloseButton
            onClick={close}
            title="Închide"
            color="#ffffff"
            style={{ marginTop: '-16px', marginRight: '-9px' }}
            role="button"
            tabIndex={0}
            onKeyDown={(event: React.KeyboardEvent) => {
              if (event.key === 'Enter' || event.key === ' ') {
                close()
              }
            }}
          />
        </Header>
        {hasOpened && (
          <ModalContent>
            <section className="section intro">
              <p>
                Acum poți instala aplicația MeniuDigital pe terminalele POS Sunmi compatibile și gestiona comenzile fără telefon
                sau tabletă.
              </p>
            </section>

            <section className="section">
              <h3>Cum funcționează?</h3>
              <ol className="steps">
                <li>Instalează aplicația MeniuDigital pe POS-ul Sunmi și conectează-te cu contul restaurantului.</li>
                <li>
                  Vizualizează comenzile primite, în timp real.
                  <img
                    className="photo"
                    src="/ordering-explainers/pos-order-on-screen.jpeg"
                    alt="Comandă afișată în aplicația de ospătar, pe POS"
                    width={900}
                    height={1200}
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li>
                  Selectează comanda și apasă „Printează”.
                  <img
                    className="photo"
                    src="/ordering-explainers/pos-print-button.jpeg"
                    alt="Butonul Printează din aplicația de ospătar"
                    width={344}
                    height={620}
                    loading="lazy"
                    decoding="async"
                  />
                </li>
                <li>
                  Bonul de comandă se tipărește imediat, fără pași suplimentari.
                  <img
                    className="photo"
                    src="/ordering-explainers/pos-printed-receipt.jpeg"
                    alt="Bon de comandă tipărit"
                    width={900}
                    height={1200}
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              </ol>
            </section>

            <section className="section">
              <h3>De ce ai nevoie?</h3>
              <p>
                Ai nevoie de sistemul de comenzi online activ în contul tău și de un POS Sunmi cu imprimantă, deblocat, care
                permite instalarea altor aplicații.
              </p>
              <p>
                Pentru o experiență cât mai bună, recomandăm{' '}
                <a
                  className="inline-link"
                  href="https://www.emag.ro/terminal-pos-mobil-smart-cu-imprimanta-si-scanner-2d-integrate-sunmi-v3-nfc-gms-edla-gps-238-x-81-8-x-16-7-mm-android-os-negru-argintiu-4002313500402/pd/DJ962K2BM/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Sunmi V3 sau un model mai nou
                </a>
                .
              </p>
              <p>Ai deja un POS? Trimite-ne modelul și verificăm dacă este compatibil.</p>
            </section>
          </ModalContent>
        )}
      </Modal>
    </>
  )
}
